
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nft/[nftId]/[multiNftId]",
      function () {
        return require("private-next-pages/nft/[nftId]/[multiNftId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nft/[nftId]/[multiNftId]"])
      });
    }
  